import React from 'react';
import styled from 'styled-components';
import { ToggleButtonGroup as ToggleButtonGroupBase } from '@mui/material';
import { ToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup/ToggleButtonGroup';

const StyledToggleButtonGroup = styled(ToggleButtonGroupBase)<
  ToggleButtonGroupProps & { $valueSelected?: boolean }
>`
  gap: 8px;

  .MuiToggleButtonGroup-grouped {
    margin: 0 !important;
    border: 1.5px solid ${({ theme }) => theme.palette.common.gray1} !important;
    border-radius: 8px !important;

    background-blend-mode: ${({ $valueSelected }) =>
      $valueSelected ? 'luminosity' : 'normal'};
    filter: grayscale(
      ${({ $valueSelected }) => ($valueSelected ? '100%' : '0')}
    );
  }
`;

const SegmentedButtonGroup = React.forwardRef(
  (props: ToggleButtonGroupProps, ref: any) => (
    <StyledToggleButtonGroup
      ref={ref}
      $valueSelected={props.value != null}
      {...props}
    />
  ),
);

export default SegmentedButtonGroup;
